import classnames from 'classnames';
import React, { forwardRef } from 'react';
import styles from "./Backdrop.module.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const Backdrop = /*#__PURE__*/forwardRef(({
  onMouseDown,
  open = true,
  children,
  className,
  onClick,
  flexCenter,
  'data-testid': dataTestId
}, ref) => {
  const backdropClassnames = classnames(styles.backdrop, className, flexCenter && styles.flexCenter);
  return open ? /*#__PURE__*/_jsx("div", {
    ref: ref,
    className: backdropClassnames,
    role: "none",
    onClick: onClick,
    onMouseDown: onMouseDown,
    "data-testid": dataTestId,
    children: children
  }) : null;
});